/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * F032 step 7b: plain names for the workout kinds. Stored tags stay the contract strings.
 */
import { WORKOUT_CATEGORIES, type WorkoutCategory } from "@lemonadetraining/contracts";

export const MAX_KINDS = 2;

export const KIND_LABELS: Record<WorkoutCategory, string> = {
  "Strength / Weightlifting": "Strength",
  "Gymnastics / Skill / Accessory": "Gymnastics & skill",
  "Metcon / EMOM": "Metcon",
  "Monostructural / Cardio": "Cardio",
  "Test Workouts": "Test (benchmark)",
};

/** The contract value a stored tag stands for (old docs carry a trailing space), or null. */
export const kindValue = (tag: string): WorkoutCategory | null => {
  const trimmed = tag.trim();
  return WORKOUT_CATEGORIES.find((c) => c === trimmed) ?? null;
};

export const kindLabel = (tag: string): string => {
  const value = kindValue(tag);
  return value ? KIND_LABELS[value] : tag;
};
